import module from 'nominas/nomina/module.js'
import template from './template.html'
import moment from 'moment'

export class NominasNominaInformacionConfiguracionComponent {
  idProyecto
  idNomina
  data
  status
  onChange
  editando = false
  nominasNomina = undefined

  $onInit () {
    this.actualizarDescripcion()
  }

  actualizar (data) {
    this.data.fecha_inicial = data.fecha_inicial
    this.data.fecha_final = data.fecha_final
    this.data.notas = data.notas

    this.actualizarDescripcion()

    this.nominasNomina.data['id_moneda'] = data.id_moneda
    this.nominasNomina.data['tipo_cambio'] = data.tipo_cambio
    this.nominasNomina.data['tipo_cambio_fecha'] = data.tipo_cambio_fecha

    this.onChange({$event: {data: data}})

    this.editando = false
  }

  actualizarDescripcion () {
    this.data.descripcion = 'Nómina '
      + this.data.tipo_nomina.toLowerCase()
      + formatoPeriodo(this.data.fecha_inicial, this.data.fecha_final)
  }
}

function formatoPeriodo (inicio, final) {
  let i = moment(inicio).format('YYYY,MMMM,D').split(','),
    f = moment(final).format('YYYY,MMMM,D').split(','),
    c = [i[0] === f[0], i[1] === f[1], i[2] === f[2]]

  if (c[0] && c[1] && c[2])
    return ' del ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
  else if (c[0] && c[1])
    return ' del ' + i[2] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
  else if (c[0])
    return ' del ' + i[2] + ' de ' + i[1] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
  else
    return ' del ' + i[2] + ' de ' + i[1] + ' de ' + i[0] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
}

module.component('nominasNominaInformacionConfiguracion', {
  controller: NominasNominaInformacionConfiguracionComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    status: '<',
    onChange: '&',
  },
  require: {
    nominasNomina: '^nomina',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/component.js